import React from 'react'
import { useIntl, FormattedHTMLMessage, Message } from 'sb-react-intl'

import ToggleTruncate from 'components/text/ToggleTruncate/ToggleTruncate'

import messages from './messages'
import s from './HeadlineWithCount.scss'


type HeadlineWithCountProps = {
  title: string | ReactIntlMessage
  desc?: string | ReactIntlMessage
  count: number
  shouldRenderSeoH1Title?: boolean
}

const HeadlineWithCount: React.FunctionComponent<HeadlineWithCountProps> = (props) => {
  const { title, desc, count, shouldRenderSeoH1Title } = props

  const intl = useIntl()

  let description = desc

  // ATTN don't replace with Message! coz ToggleTruncate requires string children!
  if (description && typeof description === 'object') {
    description = intl.formatHTMLMessage(description)
  }

  return (
    <div className={s.container}>
      <div className={s.title}>
        <Message
          tag={shouldRenderSeoH1Title ? 'h1' : 'div'}
          className={s.headline}
          text={title}
          html
        />
        <FormattedHTMLMessage
          className={s.productCount}
          tag="span"
          {...messages.productCount}
          values={{ count }}
        />
      </div>
      {
        Boolean(description) && (
          <ToggleTruncate className={s.desc} length={365}>
            {description}
          </ToggleTruncate>
        )
      }
    </div>
  )
}


export default HeadlineWithCount
